// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router'

import SectionArtists from '@/views/SectionArtists.vue'
import SectionSearch from '@/views/SectionSearch.vue'
import SectionWhiteCube from '@/views/SectionWhiteCube.vue'
import SectionArtworkCard from '@/views/SectionArtworkCard.vue'
import SectionParenthesis from '@/views/SectionParenthesis.vue'
import SectionAboutUs from '@/views/SectionAboutUs.vue'
import SectionPrivacyNote from '@/views/SectionPrivacyNote.vue'
import SectionContact from '@/views/SectionContact.vue'
import SectionArtistFull from '@/views/SectionArtistFull.vue'

export const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        { path: '/', name: 'parenthesis', component: SectionParenthesis },
        { path: '/artists/:display?', name: 'artists', component: SectionArtists, props: true },
        { path: '/artist/:id', name: 'artistfull', component: SectionArtistFull, props: true },
        { path: '/search', name: 'search', component: SectionSearch },
        { path: '/cube', name: 'cube', component: SectionWhiteCube },
        { path: '/artwork/:id', name: 'artworkcard', component: SectionArtworkCard, props: true },
        { path: '/about', name: 'about', component: SectionAboutUs },
        { path: '/privacy', name: 'privacy', component: SectionPrivacyNote },
        { path: '/contact/:id', name: 'contact', component: SectionContact, props: true },
    ],
})